import {Locale} from "next-intl";
import {SettingsNavigationProperty} from "@pata/settings";
import {getLocale, getTranslations} from "next-intl/server";

export default async function fetchInformation(): Promise<SettingsNavigationProperty[]> {
    const locale: Locale = await getLocale()
    const t = await getTranslations('Navigation')
    
    switch (locale) {
        default:
            return [
                { name: t("about-us"), path: "/about-us", htmlId: 58 },
                { name: t("about-us#aktualitates"), path: "/about-us#aktualitates", htmlId: 440 },
                { name: t("contact-us#vakances"), path: "/contact-us#vakances", htmlId: 441 },
                { name: t("contact-us#rekviziti"), path: "/contact-us#rekviziti", htmlId: 442 },
                { name: t("code-of-conduct"), path: "/code-of-conduct", htmlId: 941 },
                { name: t("whistleblowing-policy"), path: "/whistleblowing-policy", htmlId: 1180 },
                { name: t("privacy-policy"), path: "/privacy-policy", htmlId: 910 },
                { name: t("contact-us"), path: "/contact-us", htmlId: 57 },
            ]
        case "en":
            return [
                { name: t("about-us"), path: "/about-us", htmlId: 636 },
                { name: t("about-us#aktualitates"), path: "/about-us#aktualitates", htmlId: 637 },
                { name: t("contact-us"), path: "/contact-us", htmlId: 625 },
                { name: t("contact-us#rekviziti"), path: "/contact-us#rekviziti", htmlId: 639 },
                { name: t("code-of-conduct"), path: "/code-of-conduct", htmlId: 942 },
                { name: t("whistleblowing-policy"), path: "/whistleblowing-policy", htmlId: 1181 },
                { name: t("privacy-policy"), path: "/privacy-policy", htmlId: 1927 },
                { name: t("contact-us"), path: "/contact-us", htmlId: 640 },
            ]
        case "lt":
            return [
                { name: t("about-us"), path: "/about-us", htmlId: 1666 },
                { name: t("about-us#aktualitates"), path: "/about-us#aktualitates", htmlId: 1667 },
                { name: t("contact-us#rekviziti"), path: "/contact-us#rekviziti", htmlId: 1668 },
                { name: t("code-of-conduct"), path: "/code-of-conduct", htmlId: 2499 },
                { name: t("contact-us"), path: "/contact-us", htmlId: 1669 },
            ]
        case "cn":
            return [
                { name: t("about-us"), path: "/about-us", htmlId: 1428 },
                { name: t("about-us#aktualitates"), path: "/about-us#aktualitates", htmlId: 1429 },
                { name: t("contact-us#rekviziti"), path: "/contact-us#rekviziti", htmlId: 1430 },
                { name: t("contact-us"), path: "/contact-us", htmlId: 1431 },
            ]
    }
}